module.exports = __webpack_public_path__ + "img/Gerätewagen_Logistik.c126dc3b.svg";